import React, { useState, useEffect,useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import './HYBRID_Subscription_Order_S.css';

const HYBRID_Subscription_Order_S = (props) => {
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();
  let selectedData ="";
  
  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };



  

  useEffect(() => {
    document.title = "SRWAE | "+t('Hybrid Token Subscription Order');  

 const handleReturn = async () => {
    const collectClientInfo = () => {
      return {
        userAgent: navigator.userAgent,
        language: navigator.language,
        platform: navigator.platform,
        screenResolution: `${screen.width}x${screen.height}`,
        colorDepth: screen.colorDepth,
        timezoneOffset: new Date().getTimezoneOffset(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        cookieEnabled: navigator.cookieEnabled,
        javaEnabled: navigator.javaEnabled(),
        online: navigator.onLine,
        referrer: document.referrer,
        locationHref: window.location.href,
        screenOrientation: screen.orientation?.type || 'unknown'
      };
    };

    const clientInfo = collectClientInfo();

    try {
      const response = await fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_SUBSCRIPTION_ORDER/Select', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: App_Data.Data, clientInfo: clientInfo, stamp: Date.now() })
      });

      if (response.ok) {
        navigate('/HYBRID_Subscription_Order', { replace: true });
      } else {
        console.error("Select call failed with status:", response.status);
      }
    } catch (err) {
      console.error("Select fetch error:", err);
    }
  };	  
	  
	for (let i = 1; i <= 1; i++) {
	  const sectionId = `#HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_${i}_SECTION`;
	  const headerId = `#HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [1];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
	
	const searchInput = $('input[type="search"]');
 	const Temp_Search = App_Data["Object_Search"];
	if(Temp_Search!=""){
		searchInput.val(Temp_Search);
	}

	if(location.hash=="#Return"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};
		
		const clientInfo = collectClientInfo();

		fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_SUBSCRIPTION_ORDER/Select', {
		  method: 'POST',
		  headers: { 'Content-Type': 'application/json' },
		  body: JSON.stringify({ data:(App_Data&&App_Data.Data?App_Data.Data:{id:-1}) , clientInfo:clientInfo , stamp: Date.now() })
		}).catch(err => {
		  console.error("Error", err);
		});			
		navigate('/HYBRID_Subscription_Order',{replace:true});
	}
	if(location.hash=="#New"){
		setApp_Data({ ...App_Data});
		navigate('/HYBRID_Subscription_Order',{replace:true});
	}
	if(location.hash=="#Search"){
		setApp_Data({ ...App_Data});
		navigate('/HYBRID_Subscription_Order_S',{replace:true});
	}
	if(location.hash=="#Update"){
		setApp_Data({ ...App_Data});
		navigate('/HYBRID_Subscription_Order',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setApp_Data({ ...App_Data});
		navigate('/HYBRID_Subscription_Order_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setApp_Data({ ...App_Data});
		navigate('/HYBRID_Subscription_Order_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setApp_Data({ ...App_Data});
		navigate('/HYBRID_Subscription_Order_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		setApp_Data({ ...App_Data});
		navigate('/HYBRID_Subscription_Order',{replace:true});
	}
	if(location.hash=="#Export"){
		setApp_Data({ ...App_Data});
		navigate('/HYBRID_Subscription_Order',{replace:true});
	}
	if(location.hash=="#Import"){
		setApp_Data({ ...App_Data});
		navigate('/HYBRID_Subscription_Order',{replace:true});
	}
	if(location.hash=="#Help"){
		setApp_Data({ ...App_Data});
		navigate('/HYBRID_Subscription_Order',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setApp_Data({ ...App_Data});
		navigate('/HYBRID_Subscription_Order',{replace:true});
	}

     	    window.DataTableScript('#Table9');

  })  

  const [HYBRID_SUBSCRIPTION_ORDER, setHYBRID_SUBSCRIPTION_ORDER] = React.useState(null);
  const [HYBRID_SUBSCRIPTION_ORDER_S, setHYBRID_SUBSCRIPTION_ORDER_S] = React.useState(null);

  var Ids = [];
  for(var Ele in HYBRID_SUBSCRIPTION_ORDER_S){
	  for(var Sec in HYBRID_SUBSCRIPTION_ORDER_S[Ele]){
			if(Sec == "id")
				Ids.push(HYBRID_SUBSCRIPTION_ORDER_S[Ele]["id"]);
			else if(Sec == "status")
				Ids.push(HYBRID_SUBSCRIPTION_ORDER_S[Ele]["status"]);
			else if(Array.isArray(HYBRID_SUBSCRIPTION_ORDER_S[Ele][Sec]))
				  for(var Row in HYBRID_SUBSCRIPTION_ORDER_S[Ele][Sec])
					for (var Id in Row) 
						Ids.push(Id);
			else
				for (var Id in HYBRID_SUBSCRIPTION_ORDER_S[Ele][Sec]) 
					Ids.push(Id);
	  }
  }
  
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
    axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_SUBSCRIPTION_ORDER`).then((response) => {
      setHYBRID_SUBSCRIPTION_ORDER(response.data);
	  
		var Temp_Detail = [];
		Object.keys(response.data).map((key, index) => {
		  var Temp_Obj={};
		  var Temp_Val = JSON.parse(JSON.stringify(response.data[index]));
		  for(var Sec in Temp_Val){
		     if(Sec == "id")
						Temp_Obj["id"] = Temp_Val[Sec];
			 else if(Array.isArray(Temp_Val[Sec])){
					  for(var Row in Temp_Val[Sec])
						for (var Id in Temp_Val[Sec][Row]){ 
							if(Temp_Obj.hasOwnProperty(Id))
								Temp_Obj[Id] += "|||"+Temp_Val[Sec][Row][Id];
							else
								Temp_Obj[Id]=Temp_Val[Sec][Row][Id];
						}
			}else{
				for (var Id in Temp_Val[Sec]){ 
					Temp_Obj[Id] = Temp_Val[Sec][Id];
				}
			}
		  }
		  Temp_Detail.push(Temp_Obj);
	  })
	  //setALLFIELDS_S(JSON.parse(JSON.stringify(Temp_Detail)));	  

	setHYBRID_SUBSCRIPTION_ORDER_S(JSON.parse(JSON.stringify(Temp_Detail)));
	  
	  
	  
    });
	//$('#navbarNav1').show();
//$('#navbarNav6').show();

  }, []);

  if (!HYBRID_SUBSCRIPTION_ORDER_S) return <div>Loading...</div>;

 const handleLastDataHYBRID_SUBSCRIPTION_ORDER_S = async (data) => {
  };




  const handleAddHYBRID_SUBSCRIPTION_ORDER_S = async () => {
    try {
      await axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_SUBSCRIPTION_ORDER_S', JSON.parse(JSON.stringify(HYBRID_SUBSCRIPTION_ORDER_S)));

      const response = await axios.get('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_SUBSCRIPTION_ORDER_S');
      setHYBRID_SUBSCRIPTION_ORDER_S(response.data);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
  

    
const HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_SUBSCRIPTION_ORDER_S));
	Temp_Data["1"]["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_0"]=value;
	//handleAddHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data,App_Data['HYBRID_SUBSCRIPTION_ORDER_S']);
	Form_Data_onChange("1","HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_0",value,Temp_Data);
 	//handleLastDataHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data);
    setHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data);
 }; 
  
    
const HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_SUBSCRIPTION_ORDER_S));
	Temp_Data["1"]["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_1"]=value;
	//handleAddHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data,App_Data['HYBRID_SUBSCRIPTION_ORDER_S']);
	Form_Data_onChange("1","HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_1",value,Temp_Data);
 	//handleLastDataHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data);
    setHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data);
 }; 
  
    
const HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_SUBSCRIPTION_ORDER_S));
	Temp_Data["1"]["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_2"]=value;
	//handleAddHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data,App_Data['HYBRID_SUBSCRIPTION_ORDER_S']);
	Form_Data_onChange("1","HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_2",value,Temp_Data);
 	//handleLastDataHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data);
    setHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data);
 }; 
  
    
const HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_SUBSCRIPTION_ORDER_S));
	Temp_Data["1"]["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_3"]=value;
	//handleAddHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data,App_Data['HYBRID_SUBSCRIPTION_ORDER_S']);
	Form_Data_onChange("1","HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_3",value,Temp_Data);
 	//handleLastDataHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data);
    setHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data);
 }; 
  
    
const HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_SUBSCRIPTION_ORDER_S));
	Temp_Data["1"]["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_4"]=value;
	//handleAddHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data,App_Data['HYBRID_SUBSCRIPTION_ORDER_S']);
	Form_Data_onChange("1","HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_4",value,Temp_Data);
 	//handleLastDataHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data);
    setHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data);
 }; 
  
    
const HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_SUBSCRIPTION_ORDER_S));
	Temp_Data["2"]["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_2_0"]=value;
	//handleAddHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data,App_Data['HYBRID_SUBSCRIPTION_ORDER_S']);
	Form_Data_onChange("2","HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_2_0",value,Temp_Data);
 	//handleLastDataHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data);
    setHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data);
 }; 
  

const HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_SUBSCRIPTION_ORDER));
	Temp_Data["2"]["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_2_1"]=value;
	Form_Data_onChange("2","HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_2_1",value,Temp_Data);
 	//handleLastDataHYBRID_SUBSCRIPTION_ORDER(Temp_Data);
    setHYBRID_SUBSCRIPTION_ORDER(Temp_Data);
	//handleAddHYBRID_SUBSCRIPTION_ORDER(Temp_Data,App_Data['HYBRID_SUBSCRIPTION_ORDER']);
  }; 
  


const HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_SUBSCRIPTION_ORDER));
	Temp_Data["2"]["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_2_2"]=value;
	Form_Data_onChange("2","HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_2_2",value,Temp_Data);
 	//handleLastDataHYBRID_SUBSCRIPTION_ORDER(Temp_Data);
    setHYBRID_SUBSCRIPTION_ORDER(Temp_Data);
	//handleAddHYBRID_SUBSCRIPTION_ORDER(Temp_Data,App_Data['HYBRID_SUBSCRIPTION_ORDER']);
  }; 
  

    
const HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_2_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_SUBSCRIPTION_ORDER_S));
	Temp_Data["2"]["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_2_3"]=value;
	//handleAddHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data,App_Data['HYBRID_SUBSCRIPTION_ORDER_S']);
	Form_Data_onChange("2","HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_2_3",value,Temp_Data);
 	//handleLastDataHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data);
    setHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data);
 }; 
  

const HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_SUBSCRIPTION_ORDER));
	Temp_Data["3"]["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_3_0"]=value;
	Form_Data_onChange("3","HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_3_0",value,Temp_Data);
 	//handleLastDataHYBRID_SUBSCRIPTION_ORDER(Temp_Data);
    setHYBRID_SUBSCRIPTION_ORDER(Temp_Data);
	//handleAddHYBRID_SUBSCRIPTION_ORDER(Temp_Data,App_Data['HYBRID_SUBSCRIPTION_ORDER']);
  }; 
  

  
      
const HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_3_1_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_SUBSCRIPTION_ORDER_S));
	Temp_Data["3"]["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_3_1"]=value ? true : false; // optionally just use boolean
	//handleAddHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data,App_Data['HYBRID_SUBSCRIPTION_ORDER_S']);
	Form_Data_onChange("3","HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_3_1",value,Temp_Data);
 	//handleLastDataHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data);
    setHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data);
 }; 
  


    
const HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_SUBSCRIPTION_ORDER_S));
	Temp_Data["4"]["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_4_0"]=value;
	//handleAddHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data,App_Data['HYBRID_SUBSCRIPTION_ORDER_S']);
	Form_Data_onChange("4","HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_4_0",value,Temp_Data);
 	//handleLastDataHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data);
    setHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data);
 }; 
  
    
const HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_4_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_SUBSCRIPTION_ORDER_S));
	Temp_Data["4"]["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_4_1"]=value;
	//handleAddHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data,App_Data['HYBRID_SUBSCRIPTION_ORDER_S']);
	Form_Data_onChange("4","HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_4_1",value,Temp_Data);
 	//handleLastDataHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data);
    setHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data);
 }; 
  

const HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_SUBSCRIPTION_ORDER));
	Temp_Data["9"]["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_0"]=value;
	Form_Data_onChange("9","HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_0",value,Temp_Data);
 	//handleLastDataHYBRID_SUBSCRIPTION_ORDER(Temp_Data);
    setHYBRID_SUBSCRIPTION_ORDER(Temp_Data);
	//handleAddHYBRID_SUBSCRIPTION_ORDER(Temp_Data,App_Data['HYBRID_SUBSCRIPTION_ORDER']);
  }; 
  

    
const HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_SUBSCRIPTION_ORDER_S));
	Temp_Data["9"]["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_1"]=value;
	//handleAddHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data,App_Data['HYBRID_SUBSCRIPTION_ORDER_S']);
	Form_Data_onChange("9","HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_1",value,Temp_Data);
 	//handleLastDataHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data);
    setHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data);
 }; 
  
    
const HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_SUBSCRIPTION_ORDER_S));
	Temp_Data["9"]["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_2"]=value;
	//handleAddHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data,App_Data['HYBRID_SUBSCRIPTION_ORDER_S']);
	Form_Data_onChange("9","HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_2",value,Temp_Data);
 	//handleLastDataHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data);
    setHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data);
 }; 
  
    
const HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_SUBSCRIPTION_ORDER_S));
	Temp_Data["9"]["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_3"]=value;
	//handleAddHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data,App_Data['HYBRID_SUBSCRIPTION_ORDER_S']);
	Form_Data_onChange("9","HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_3",value,Temp_Data);
 	//handleLastDataHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data);
    setHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data);
 }; 
  
    
const HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_SUBSCRIPTION_ORDER_S));
	Temp_Data["9"]["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_4"]=value;
	//handleAddHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data,App_Data['HYBRID_SUBSCRIPTION_ORDER_S']);
	Form_Data_onChange("9","HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_4",value,Temp_Data);
 	//handleLastDataHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data);
    setHYBRID_SUBSCRIPTION_ORDER_S(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID) => {

};


 
   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
	selectedData = HYBRID_SUBSCRIPTION_ORDER_S.find(e => e.id == selectedRowId);
    //App_Data.Return_Data=selectedRowId;
    App_Data.Object_Return=selectedRowId;
    //console.log(event.currentTarget.querySelector('td').textContent);
    App_Data.Object_Text=selectedRowId+";"+event.currentTarget.querySelector('td').textContent;
    App_Data.Object_Id=selectedRowId;
	App_Data.Data=selectedData;
	setApp_Data({ ...App_Data})
    window.location.hash = 'Return';
   };
 
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
			  {t('Select Hybrid Token Subscription Order')}
			  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
			</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item">
					  <a id="navbarNav1" className="nav-link" href="#Return">{t(`Return`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>		 
         {/* Search Fields*/}
         <div className="container-fluid mt-5">
            <h2  id="HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Advanced Search`)} <span className="toggle-icon">v</span></h2>
            <div  id="HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`HYBRID Subscription ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_0" type="text" className="form-control" placeholder="HYBRID Subscription ID"  
						onChange={HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter HYBRID Subscription ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Offering ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_1" type="text" className="form-control" placeholder="Offering ID"  
						onChange={HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Offering ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Investor ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_2" type="text" className="form-control" placeholder="Investor ID"  
						onChange={HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Investor ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Requested Amount USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_3" type="text" className="form-control" placeholder="Requested Amount USD"  
						onChange={HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Requested Amount USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approved Amount USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_4" type="text" className="form-control" placeholder="Approved Amount USD"  
						onChange={HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_4_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Approved Amount USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Token Quantity`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_2_0" type="text" className="form-control" placeholder="Token Quantity"  
						onChange={HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_2_0_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_2_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Token Quantity`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Payment Method`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_2_1"   onChange={HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_2_1_Change} className="form-control" name="Payment Method"  >
						  <option value="ACH">ACH</option>
						  <option value="Wire">Wire</option>
						  <option value="Card">Card</option>
						  <option value="Check">Check</option>
						  <option value="Internal Transfer">Internal Transfer</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Payment Method
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Payment Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_2_2"   onChange={HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_2_2_Change} className="form-control" name="Payment Status"  >
						  <option value="Not Started">Not Started</option>
						  <option value="Pending">Pending</option>
						  <option value="Received">Received</option>
						  <option value="Cleared">Cleared</option>
						  <option value="Failed">Failed</option>
						  <option value="Refunded">Refunded</option>
						  <option value="Cancelled">Cancelled</option>
						  <option value="Paid">Paid</option>
						  <option value="Partially Paid">Partially Paid</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Payment Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Escrow Deposit ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_2_3" type="text" className="form-control" placeholder="Escrow Deposit ID"  
						onChange={HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_2_3_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_2_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Escrow Deposit ID`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Subscription Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_3_0"   onChange={HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_3_0_Change} className="form-control" name="Subscription Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Submitted">Submitted</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Funded">Funded</option>
						  <option value="Cancelled">Cancelled</option>
						  <option value="Closed">Closed</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Subscription Status
				     </div>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_3_1" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Risk Acknowledgment Completed`)} <input id="HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_3_1" type="checkbox" style={{ marginLeft: '5px' }}  onChange={HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_3_1_Change} 
					  checked={HYBRID_SUBSCRIPTION_ORDER_S?.["3"]?.["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_3_1"] === "true" || HYBRID_SUBSCRIPTION_ORDER_S?.["3"]?.["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_3_1"] === true} />
					</label>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approved By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_4_0" type="text" className="form-control" placeholder="Approved By"  
						onChange={HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_4_0_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_4_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Approved By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approved At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_4_1" type="text" className="form-control" placeholder="Approved At"  
						onChange={HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_4_1_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_4_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Approved At`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_0"   onChange={HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_1" type="text" className="form-control" placeholder="Created By"  
						onChange={HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_2" type="text" className="form-control" placeholder="Created At"  
						onChange={HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_3" type="text" className="form-control" placeholder="Updated By"  
						onChange={HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_4" type="text" className="form-control" placeholder="Updated At"  
						onChange={HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
		 {/* Query Result*/}
         <div className="container-fluid mt-5">
            <h2 style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Query Result`)}</h2>
            <div className="row">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('9')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table9" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`HYBRID Subscription ID`)}</th>
                        <th>{t(`Offering ID`)}</th>
                        <th>{t(`Investor ID`)}</th>
                        <th>{t(`Requested Amount USD`)}</th>
                        <th>{t(`Approved Amount USD`)}</th>
                        <th>{t(`Token Quantity`)}</th>
                        <th>{t(`Payment Method`)}</th>
                        <th>{t(`Payment Status`)}</th>
                        <th>{t(`Escrow Deposit ID`)}</th>
                        <th>{t(`Subscription Status`)}</th>
                        <th>{t(`Risk Acknowledgment Completed`)}</th>
                        <th>{t(`Approved By`)}</th>
                        <th>{t(`Approved At`)}</th>
                        <th>{t(`Record Status`)}</th>
                        <th>{t(`Created By`)}</th>
                        <th>{t(`Created At`)}</th>
                        <th>{t(`Updated By`)}</th>
                        <th>{t(`Updated At`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {HYBRID_SUBSCRIPTION_ORDER_S.map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
						<td>{e["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_0"]} </td>
						<td>{e["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_1"]} </td>
						<td>{e["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_2"]} </td>
						<td>{e["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_3"]} </td>
						<td>{e["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_1_4"]} </td>
						<td>{e["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_2_0"]} </td>
						<td>{e["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_2_1"]} </td>
						<td>{e["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_2_2"]} </td>
						<td>{e["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_2_3"]} </td>
						<td>{e["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_3_0"]} </td>
						<td>{e["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_3_1"]} </td>
						<td>{e["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_4_0"]} </td>
						<td>{e["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_4_1"]} </td>
						<td>{e["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_0"]} </td>
						<td>{e["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_1"]} </td>
						<td>{e["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_2"]} </td>
						<td>{e["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_3"]} </td>
						<td>{e["HYBRID_04_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_HYBRID_SUBSCRIPTION_ORDER_9_4"]} </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
  </>;
};

export default HYBRID_Subscription_Order_S;  